import { createSlice } from '@reduxjs/toolkit';

const tableSlice = createSlice({
  name: 'table',
  initialState: {
    selectedRow: {}
  },
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    resetSelectedRow: (state) => {
      state.selectedRow = {};
    }
  },
});

export const {
  setSelectedRow,
  resetSelectedRow
} = tableSlice.actions;

export default tableSlice.reducer;
